/* Links to other sites open in a new tab.
   Same-site links, anchors, mailto: and tel: are left alone, as are links that already set a target.
   Runs once on load and again when new markup is injected (cart drawer, quick view, search results). */
(function () {
  'use strict';
  var site = location.hostname.replace(/^www\./, '');
  function internal(host) {
    host = (host || '').replace(/^www\./, '');
    return !host ||
      host === site ||
      host === 'babygo.uk' ||
      host.slice(-11) === '.babygo.uk' ||
      host.indexOf('shopify.com') > -1;
  }
  function decorate() {
    var links = document.querySelectorAll('a[href^="http"]:not([target])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (internal(a.hostname)) continue;
      a.setAttribute('target', '_blank');
      var rel = a.getAttribute('rel') || '';
      if (rel.indexOf('noopener') === -1) a.setAttribute('rel', (rel ? rel + ' ' : '') + 'noopener');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(decorate, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
